import { iconPaths, type IconName } from './assets';
export function Icon({
  name,
  filled = false,
  className = '',
}: {
  name: IconName;
  filled?: boolean;
  className?: string;
}) {
  return (
    <svg
      className={`design-icon ${className}`}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {iconPaths[name].map((d, index) => (
        <path d={d} key={index} />
      ))}
    </svg>
  );
}
